export default __webpack_public_path__ + "static/media/persona.972a4333.png";